var _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgILoveIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49978 4.5C7.99836 2.75072 10.8748 4.875 11.9998 6.375C13.1248 4.875 16.0012 2.75073 19.4998 4.5C23.9998 6.74999 22.8748 12.375 19.4998 15.75C17.853 17.3968 14.9527 20.2971 12.8314 21.9103C12.3413 22.283 11.6709 22.2663 11.1918 21.8796C9.2473 20.31 6.12356 17.3738 4.49978 15.75C1.12477 12.375 -0.000217321 6.75 4.49978 4.5Z",
    fill: "#F8312F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 6.37499V8.66186C12.952 6.64876 15.3187 3.96038 19.2432 4.37809C15.861 2.85467 13.0971 4.91181 11.9998 6.37499Z",
    fill: "#CA0B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95905 4.15268C7.6959 3.71254 6.16862 3.66559 4.49978 4.5C-0.000217078 6.75 1.12477 12.375 4.49978 15.75C6.12356 17.3738 9.2473 20.31 11.1918 21.8796C11.6709 22.2663 12.3413 22.283 12.8314 21.9103C13.022 21.7653 13.219 21.6099 13.4207 21.446C11.2797 19.8393 8.27504 17.3071 6.64411 15.8494C2.92651 12.5265 1.68733 6.98841 6.64411 4.77319C7.44947 4.41327 8.2249 4.2199 8.95905 4.15268Z",
    fill: "#CA0B4A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6079,
    cy: 9.4453,
    rx: 2.12666,
    ry: 3.58594,
    transform: "rotate(30 17.6079 9.4453)",
    fill: "#F37366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgILoveIt);
export default __webpack_public_path__ + "static/media/i-love-it.10cb54ffa8c1d97cb559e30fc3837be1.svg";
export { ForwardRef as ReactComponent };